export enum ReviewStateKey {
  TriggerDate = "trigger-date",
  PositiveMoment = "positive-moment-count",
  TriggerStatus = "trigger-status",
}

export enum TriggerStatus {
  Active = "active",
  Inactive = "inactive",
}

export abstract class AppReviewState {
  public static get(key: ReviewStateKey): string | null {
    return localStorage.getItem(key);
  }

  public static set(key: ReviewStateKey, value: string | number | TriggerStatus) {
    localStorage.setItem(key, String(value));
  }

  public static getThreshold(): number {
    return !!this.get(ReviewStateKey.TriggerDate) ? 14 : 7;
  }

  public static clear(key: ReviewStateKey) {
    localStorage.removeItem(key);
  }
}
